import React, { useState } from "react";
import { connect } from "react-redux";
import { IconLabel, Drawer } from "ctia-ui";
import CenterComments from "containers/ControlPanel/Payments/ASC/CenterComments";
import { clearComments } from "actions/comments";

const ShowCommentsASC = ({ center, asc, clearComments }) => {
  const [showComments, setShowComments] = useState(false);
  const toggleCommentsDrawer = () => {
    if (!showComments) clearComments();
    setShowComments(!showComments);
  };

  // how many comments
  const counter = center[`ASCCommentsCount${asc.invoicingYear}`];

  return (
    <div>
      <IconLabel awesomeIcon="comments" />{" "}
      <span
        className="glow-link cursor-pointer"
        onClick={() => toggleCommentsDrawer()}
      >
        Comments {counter > 0 && `(${counter})`}
      </span>
      <Drawer
        position="right"
        show={showComments}
        title="View/Add Comments"
        toggleDrawer={toggleCommentsDrawer}
        content={
          <CenterComments
            companyId={center.id}
            centerName={center.name}
            flagCode={center.country}
          />
        }
        width="350"
      />
    </div>
  );
};

function mapStateToProps({ asc }) {
  return { asc };
}

export default connect(mapStateToProps, {
  clearComments
})(ShowCommentsASC);
